import { TestDefinition, QuestionType } from '../../types';

// Scale 0-3 for PID-5-BF
const pid5Scale = [
  { label: '0 - Very False or Often False', value: 0 },
  { label: '1 - Sometimes False', value: 1 },
  { label: '2 - Sometimes True', value: 2 },
  { label: '3 - Very True or Often True', value: 3 }
];

export const TESTS_PERSONALIDAD: TestDefinition[] = [
  {
    id: 'pid-5-bf',
    code: 'PID-5-BF',
    name: 'Personality Inventory for DSM-5 Brief Form',
    category: 'Personality',
    description: 'Assessment of maladaptive personality traits according to DSM-5. 25 items evaluating 5 domains: Negative Affectivity, Detachment, Antagonism, Disinhibition and Psychoticism. Developed by APA (2013).',
    questions: [
      // NEGATIVE AFFECTIVITY (5 items)
      {
        id: 'p1',
        text: '1. People would describe me as reckless',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Negative Affectivity'
      },
      {
        id: 'p2',
        text: '2. I feel like I have no worth',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Negative Affectivity'
      },
      {
        id: 'p3',
        text: '3. I get embarrassed easily in social situations',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Negative Affectivity'
      },
      {
        id: 'p4',
        text: '4. I have very sudden mood changes',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Negative Affectivity'
      },
      {
        id: 'p5',
        text: '5. I worry about almost everything',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Negative Affectivity'
      },

      // DETACHMENT (5 items)
      {
        id: 'p6',
        text: '6. I am not interested in making friends',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Detachment'
      },
      {
        id: 'p7',
        text: '7. I avoid most social situations',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Detachment'
      },
      {
        id: 'p8',
        text: '8. I feel no emotion or enthusiasm about most things',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Detachment'
      },
      {
        id: 'p9',
        text: '9. I rarely feel strong emotions',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Detachment'
      },
      {
        id: 'p10',
        text: '10. I have no interest in establishing romantic relationships',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Detachment'
      },

      // ANTAGONISM (5 items)
      {
        id: 'p11',
        text: '11. I do not care if I offend other people to get what I want',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonism'
      },
      {
        id: 'p12',
        text: '12. I do not respect the rules of society',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonism'
      },
      {
        id: 'p13',
        text: '13. I cannot resist the impulse to manipulate others',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonism'
      },
      {
        id: 'p14',
        text: '14. I cheat or deceive others',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonism'
      },
      {
        id: 'p15',
        text: '15. I tend to get annoyed or irritated with people who do not do things my way',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Antagonism'
      },

      // DISINHIBITION (5 items)
      {
        id: 'p16',
        text: '16. I often act impulsively',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Disinhibition'
      },
      {
        id: 'p17',
        text: '17. I tend to get distracted easily',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Disinhibition'
      },
      {
        id: 'p18',
        text: '18. People tell me I am irresponsible',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Disinhibition'
      },
      {
        id: 'p19',
        text: '19. I do risky things without thinking about the consequences',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Disinhibition'
      },
      {
        id: 'p20',
        text: '20. I often let things get into a mess',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Disinhibition'
      },

      // PSYCHOTICISM (5 items)
      {
        id: 'p21',
        text: '21. I have some unusual experiences that most people do not have',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psychoticism'
      },
      {
        id: 'p22',
        text: '22. Sometimes I do things that others find strange',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psychoticism'
      },
      {
        id: 'p23',
        text: '23. I have had experiences that I cannot explain',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psychoticism'
      },
      {
        id: 'p24',
        text: '24. I have thoughts that seem strange to others',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psychoticism'
      },
      {
        id: 'p25',
        text: '25. I have difficulty staying focused on my thoughts',
        type: QuestionType.LIKERT,
        options: pid5Scale,
        subscale: 'Psychoticism'
      }
    ],
    subscales: [
      {
        name: 'Negative Affectivity',
        questionIds: ['p1', 'p2', 'p3', 'p4', 'p5'],
        description: 'Emotional lability, anxiety, insecurity, hostility'
      },
      {
        name: 'Detachment',
        questionIds: ['p6', 'p7', 'p8', 'p9', 'p10'],
        description: 'Isolation, anhedonia, affective restriction'
      },
      {
        name: 'Antagonism',
        questionIds: ['p11', 'p12', 'p13', 'p14', 'p15'],
        description: 'Manipulation, deceit, grandiosity, callousness'
      },
      {
        name: 'Disinhibition',
        questionIds: ['p16', 'p17', 'p18', 'p19', 'p20'],
        description: 'Impulsivity, irresponsibility, distractibility, risk-taking'
      },
      {
        name: 'Psychoticism',
        questionIds: ['p21', 'p22', 'p23', 'p24', 'p25'],
        description: 'Unusual perceptual experiences, unusual beliefs'
      }
    ],
    interpretations: [
      { min: 0, max: 18, label: 'Adaptive Traits', color: 'bg-green-100 text-green-800' },
      { min: 19, max: 37, label: 'Mild Traits', color: 'bg-yellow-100 text-yellow-800' },
      { min: 38, max: 56, label: 'Moderate Traits', color: 'bg-orange-100 text-orange-800' },
      { min: 57, max: 75, label: 'Marked Traits', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'bfi-10',
    code: 'BFI-10',
    name: 'Big Five Inventory - 10 Items',
    category: 'Personality',
    description: 'Ultra-brief 10-item version to assess the Big Five personality traits. Developed by Rammstedt & John (2007). Self-administered. Useful for quick screening of personality dimensions.',
    questions: [
      { id: 'bfi1', text: '1. I see myself as someone who... is reserved', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]},
      { id: 'bfi2', text: '2. I see myself as someone who... is generally trusting', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]},
      { id: 'bfi3', text: '3. I see myself as someone who... tends to be lazy', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]},
      { id: 'bfi4', text: '4. I see myself as someone who... is relaxed, handles stress well', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]},
      { id: 'bfi5', text: '5. I see myself as someone who... has few artistic interests', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]},
      { id: 'bfi6', text: '6. I see myself as someone who... is outgoing, sociable', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]},
      { id: 'bfi7', text: '7. I see myself as someone who... tends to find fault with others', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]},
      { id: 'bfi8', text: '8. I see myself as someone who... does a thorough job', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]},
      { id: 'bfi9', text: '9. I see myself as someone who... gets nervous easily', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]},
      { id: 'bfi10', text: '10. I see myself as someone who... has an active imagination', type: QuestionType.LIKERT, options: [{label: 'Strongly disagree', value: 1}, {label: 'Disagree', value: 2}, {label: 'Neutral', value: 3}, {label: 'Agree', value: 4}, {label: 'Strongly agree', value: 5}]}
    ],
    interpretations: [
      { min: 10, max: 23, label: 'Low Profile on Positive Traits', color: 'bg-blue-100 text-blue-800' },
      { min: 24, max: 36, label: 'Moderate Profile', color: 'bg-green-100 text-green-800' },
      { min: 37, max: 50, label: 'High Profile on Positive Traits', color: 'bg-purple-100 text-purple-800' }
    ]
  }
];
